import en from './en.json'
import it from './it.json'

export const reportsTranslations = {
	en,
	it
} as const
